import moment from 'moment';
import { SyllabusAssignmentDto } from '../../apis/sherpath-course-management-service/sherpath-course-management-service.dtos';
import { isValidDate } from '../../utilities/app.utilities';
import {
  EXTERNAL_LINK_ASSIGNMENT_EDITOR_PAGE_TITLE,
  ExternalLinkDefaultSteps,
  ExternalLinkStep,
  MAX_URL_STRING_LENGTH,
  URL_REG_EX
} from './external-link-assignment.constants';
import {
  BaseAssignmentEditorProps,
  BaseAssignmentEditorState
} from '../../hocs/with-base-assignment-editor/withBaseAssignmentEditor.hoc';
import {
  getDefaultAssignmentEditorState,
  updateStepsOnNav
} from '../../hocs/with-base-assignment-editor/with-base-assignment-editor.utilities';
import { AssignmentFormError } from '../../hocs/with-base-assignment-editor/with-base-assignment-editor.models';
import { AssignmentType } from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import { MAX_ASSIGNMENT_TITLE_CHAR_LENGTH } from '../../components/assignment-editor/assignment-editor.constant';
import { ActiveSyllabusItemTypeDto } from '../../apis/sherpath-syllabus-service/sherpath-syllabus-service.constants';

export const isValidUrlFormat = (urlString: string): boolean => {
  const urlPattern = new RegExp(URL_REG_EX);
  return urlPattern.test(urlString);
};

export const hasValidUrlProtocol = (urlString: string): boolean => {
  const url = new URL(urlString);
  return url.protocol === 'https:';
};

export const validateExternalLink = (
  syllabusAssignmentDto: SyllabusAssignmentDto,
  baseState: BaseAssignmentEditorState,
  baseProps: BaseAssignmentEditorProps
): AssignmentFormError[] => {
  const { messages } = baseProps;
  const errors = [];

  if (!syllabusAssignmentDto.assignment.title?.length) {
    errors.push({
      message: messages.ASSIGNMENT_TITLE_IS_EMPTY,
      stepId: ExternalLinkStep.STEP1
    });
  }

  const availableDate = moment(syllabusAssignmentDto.assignment.availableDate).toDate();

  if (baseState.hasAvailableDate && !isValidDate(availableDate)) {
    errors.push({
      message: messages.INVALID_AVAILABILITY_DATE,
      stepId: ExternalLinkStep.STEP1
    });
  }
  if (
    baseState.assignment?.title
    && baseState.assignment.title.length > MAX_ASSIGNMENT_TITLE_CHAR_LENGTH
  ) {
    errors.push({
      message: messages.ENTRY_EXCEEDS_LENGTH_LIMIT,
      stepId: ExternalLinkStep.STEP1,
    });
  }

  if (
    baseState.assignment?.assignmentGoals
    && baseState.assignment.assignmentGoals.length > 0
  ) {
    const urlString = baseState.assignment.assignmentGoals[0].text;

    if (urlString.length > MAX_URL_STRING_LENGTH) {
      errors.push({
        message: messages.ENTRY_EXCEEDS_LENGTH_LIMIT,
        stepId: ExternalLinkStep.STEP1,
      });
    }
    if (!isValidUrlFormat(urlString)) {
      errors.push({
        message: messages.INVALID_URL_FORMAT,
        stepId: ExternalLinkStep.STEP1,
      });
    }
    if (isValidUrlFormat(urlString) && !hasValidUrlProtocol(urlString)) {
      errors.push({
        message: messages.INVALID_URL_PROTOCOL,
        stepId: ExternalLinkStep.STEP1,
      });
    }
  }
  return errors;
};

export const getExternalLinkDefaultState = (): BaseAssignmentEditorState => {
  return {
    ...getDefaultAssignmentEditorState(),
    assignmentType: AssignmentType.CUSTOM_LINK,
    hasDueDate: false,
    showDueDate: false,
    showGrading: false,
    showDisplayName: true,
    pageTitle: EXTERNAL_LINK_ASSIGNMENT_EDITOR_PAGE_TITLE,
    steps: updateStepsOnNav(ExternalLinkDefaultSteps, 0),
    isReadOnlyDisplayName: false,
    newSyllabusItemType: ActiveSyllabusItemTypeDto.CUSTOM_LINK
  };
};
